import React from 'react'

import { Route } from 'react-router-dom'

import TrackRememberedUrl from '../../RememberedRedirect/TrackRememberedUrl'
import AuthShieldComponent from './AuthShieldComponent'

interface IAuthShieldRouteProps {
  authedComponent: React.ComponentType<any> | string
  unauthedComponent: React.ComponentType<any> | string
  componentProps?: {
    [key: string]: any
  }
  [key: string]: any
}

const AuthShieldRoute = ({
  authedComponent: AuthedComponent = 'div',
  unauthedComponent: UnauthedComponent = 'div',
  componentProps,
  path,
  ...rest
}: IAuthShieldRouteProps) => {
  return (
    <AuthShieldComponent
      component={Route}
      path={path}
      {...rest}
      propsAuthed={{
        render: (props: any) => {
          return (
            <AuthedComponent
              {...componentProps}
              {...props}
            />
          )
        },
      }}
      propsUnauthed={{
        render: (props: any) => {
          return (
            <>
              <UnauthedComponent
                {...componentProps}
                {...props}
              />
              <TrackRememberedUrl />
            </>
          )
        },
      }}
    />
  )
}

export default AuthShieldRoute
